import { Text as BaseText } from '@react-pdf/renderer';
import * as React from 'react';
import openSans400 from './fonts/open-sans/300';
import type { Style, TextProps as BaseTextProps } from '@react-pdf/types';
import sourceSansPro400 from './fonts/source-sans-pro/400';
import sourceSansPro600 from './fonts/source-sans-pro/600';

interface TextProps extends BaseTextProps {
  variant?: 'default' | 'bold' | 'small' | 'smallest';
  style?: Style;
  children?: React.ReactNode;
}

export function Text({ variant = 'default', style = {}, ...rest }: TextProps) {
  const tokens: Record<typeof variant, Style> = {
    default: { ...sourceSansPro400, fontSize: 10 },
    smallest: { ...sourceSansPro400, fontSize: 6, lineHeight: 1 },
    small: { ...sourceSansPro400, fontSize: 8, lineHeight: 1.2 },
    bold: { ...sourceSansPro600, fontSize: 12 },
  };
  return <BaseText style={[tokens[variant], style]} {...rest} />;
}

interface TitleProps extends BaseTextProps {
  variant?: 'default' | 'small' | 'large';
  style?: Style;
  children?: React.ReactNode;
}

export function Title({
  variant = 'default',
  style = {},
  ...rest
}: TitleProps) {
  const tokens: Record<typeof variant, Style> = {
    small: { ...openSans400, fontSize: 8, lineHeight: 1 },
    default: { ...openSans400, fontSize: 10, lineHeight: 1 },
    large: { ...openSans400, fontSize: 16, lineHeight: 1.3 },
  };
  return <BaseText style={[tokens[variant], style]} {...rest} />;
}
